module.exports = __webpack_public_path__ + "media/images/static/top/urban/bg_right-2db0add93c3155e67db1e6569f038767.png";